import UserInfo from "./pages/checkout-page";
import Checkout from "./pages/checkout-page/Checkout";
import DemoPage from "./pages/demo-page";
import Provider from "./contexts/provider";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PayDataProvider from "./contexts/PayDataContext";
import PayPage from "./pages/pay/reference";
import "./index.scss";
import ViewProvider from "./contexts/view.context";
import UrlAuthProvider from "./contexts/urlauth.context";
import UrlBodyProvider from "./contexts/urlBody.context";

function App() {
  return (
    <BrowserRouter>
      <Provider>
        <PayDataProvider>
          <ViewProvider>
            <UrlAuthProvider>
              <UrlBodyProvider>
                <Routes>
                  <Route path="/" element={<DemoPage />} />
                  <Route path="/pay/:payCode" element={<Checkout />} />
                  <Route path="/checkout/:payCode" element={<UserInfo />} />
                </Routes>
              </UrlBodyProvider>
            </UrlAuthProvider>
          </ViewProvider>
        </PayDataProvider>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
